<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="my-2 flex align-items-center">
        <div class="me-2">
          @if (tabview.activeIndex == 2) {
            <patron-sort-widget
              [findOptions]="customersFindOptions"
              (onSubmit)="applyOrder($event)"></patron-sort-widget>
          }
        </div>
        <div>
          @if (tabview.activeIndex == 2) {
            <patron-filter-widget
              [findOptions]="customersFindOptions"
              (onSubmit)="goToFirstPageCustomers()"></patron-filter-widget>
          }
        </div>
      </div>

      <div class="my-2 flex align-items-center">
        @if (bwUser?.is_user) {
          <patron-button
            iconName="bi-people"
            color="secondary"
            (click)="openCloneModal()"
            class="me-2">
            Clonar dados
          </patron-button>
        }

        @if (bwUser?.is_supplier) {
          <patron-button
            iconName="bi-key"
            color="secondary"
            (click)="openResetPasswordModal()"
            class="me-2">
            Reset senha
          </patron-button>
        }

        @if (shouldShowManagementPasswordButton()) {
          <patron-button
            iconName="bi-shield-lock"
            color="secondary"
            (click)="openManagementPasswordModal()"
            class="me-2">
            Senha Gestão
          </patron-button>
        }

        @if (tabview.activeIndex == 0) {
          <patron-button (click)="saveBwUser()" iconName="bi-check2" [loading]="savingBwUser">
            Salvar
          </patron-button>
        }

        @if (tabview.activeIndex == 2) {
          <patron-search-widget
            (onSearch)="onSearchCustomer($event)"
            #customersSearchWidget
            placeholder="Pesquisar clientes">
          </patron-search-widget>
        }

        @if (tabview.activeIndex == 3) {
          <div class="flex align-items-center">
            <patron-search-widget
              (onSearch)="onSearchItem($event)"
              #itemsSearchWidget
              placeholder="Pesquisar itens"
              class="me-2">
            </patron-search-widget>
            <patron-search-modal
              path="items"
              [findOptions]="searchItemsFindOptions"
              modal-title="Adicionar itens ao usuário"
              (onConfirm)="insertRelation($event, 'items')">
              <patron-icon name="bi-plus-lg" class="me-2"></patron-icon>
              Itens
            </patron-search-modal>
          </div>
        }

        @if (tabview.activeIndex == 4) {
          <patron-search-modal
            path="stock-locales"
            [findOptions]="searchStockLocalesFindOptions"
            modal-title="Adicionar locais de estoque ao usuário"
            (onConfirm)="insertRelation($event, 'stock_locales')">
            <patron-icon name="bi-plus-lg" class="me-2"></patron-icon>
            Locais de estoque
          </patron-search-modal>
        }

        @if (tabview.activeIndex == 5) {
          <patron-search-modal
            path="price-tables"
            [findOptions]="searchPriceTablesFindOptions"
            modal-title="Adicionar tabelas de preço ao usuário"
            (onConfirm)="insertRelation($event, 'price_tables')">
            <patron-icon name="bi-plus-lg" class="me-2"></patron-icon>
            Tabelas de preço
          </patron-search-modal>
        }

        @if (tabview.activeIndex == 6) {
          <patron-search-modal
            path="payment-conditions"
            [findOptions]="searchPaymentConditionsFindOptions"
            modal-title="Adicionar condições de pagamento ao usuário"
            (onConfirm)="insertRelation($event, 'payment_conditions')">
            <patron-icon name="bi-plus-lg" class="me-2"></patron-icon>
            Condições de pagamento
          </patron-search-modal>
        }

        @if (tabview.activeIndex == 13) {
          <patron-search-modal
            path="departments"
            [findOptions]="searchDepartmentsFindOptions"
            modal-title="Adicionar departamentos ao usuário"
            (onConfirm)="addUserToDepartment($event[0], false)">
            <patron-icon name="bi-plus-lg" class="me-2"></patron-icon>
            Departamentos
          </patron-search-modal>
        }

        @if (tabview.activeIndex == 9) {
          <patron-button (click)="saveUser()" iconName="bi-check2" [loading]="savingUser">
            Salvar
          </patron-button>
        }
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  @if (isLicenseControlActive && !currentLicense) {
    <patron-alert color="warning" class="mb-3 d-block">
      Este grupo empresa tem o controle de licenças de usuário ativo. Sem um assento de licença
      vinculado, o usuário fica sem acesso ao sistema.
    </patron-alert>
  }
  <div class="card mt-3">
    <div class="card-body">
      <patron-tabview
        [tabs]="tabs"
        [activeIndex]="0"
        [scrollable]="bwUser?.is_user ?? false"
        #tabview>
        <ng-template #basicTab>
          <div class="flex justify-content-center row">
            <div class="col-lg-6">
              <patron-form [formGroup]="basicForm">
                @if (user?.name) {
                  <patron-form-field [formGroup]="basicForm" formControlName="name" label="Nome">
                  </patron-form-field>
                }

                @if (user?.ref) {
                  <patron-form-field [formGroup]="basicForm" formControlName="ref" label="Ref">
                  </patron-form-field>
                }

                @if (user?.login) {
                  <patron-form-field [formGroup]="basicForm" formControlName="login" label="Login">
                  </patron-form-field>
                }

                @if (user?.email) {
                  <patron-form-field [formGroup]="basicForm" formControlName="email" label="Email">
                  </patron-form-field>
                }

                <patron-form-field
                  [formGroup]="basicForm"
                  formControlName="last_access"
                  label="Ultimo acesso">
                </patron-form-field>

                <div class="mb-3">
                  <label class="form-label d-block">Tipo</label>
                  <div class="d-flex gap-2 flex-wrap">
                    <patron-badge
                      [color]="
                        bwUser?.is_customer
                          ? patronUtils.getAccessTypeColor('customer')
                          : 'secondary'
                      "
                      [class.badge-inactive]="!bwUser?.is_customer">
                      {{ patronUtils.getAccessTypeLabel('customer') }}
                    </patron-badge>
                    <patron-badge
                      [color]="
                        bwUser?.is_supplier
                          ? patronUtils.getAccessTypeColor('supplier')
                          : 'secondary'
                      "
                      [class.badge-inactive]="!bwUser?.is_supplier">
                      {{ patronUtils.getAccessTypeLabel('supplier') }}
                    </patron-badge>
                    <patron-badge
                      [color]="
                        bwUser?.is_user ? patronUtils.getAccessTypeColor('user') : 'secondary'
                      "
                      [class.badge-inactive]="!bwUser?.is_user">
                      {{ patronUtils.getAccessTypeLabel('user') }}
                    </patron-badge>
                  </div>
                </div>

                <patron-select
                  [multiple]="true"
                  [formGroup]="basicForm"
                  formControlName="bw_user_profiles"
                  bindLabel="name"
                  label="Perfis"
                  modelName="profiles"
                  [findOptions]="profilesFindOptions"
                  [addItemProperties]="profilesAddItemProperties"
                  #profileSelect>
                </patron-select>

                @if (bwUser?.is_customer) {
                  <div>
                    <patron-switch
                      [formGroup]="basicForm"
                      formControlName="show_prices"
                      [trueValue]="1"
                      [falseValue]="0"
                      label="Mostrar preços">
                    </patron-switch>
                    @if (
                      (panelConfig$ | async)?.show_prices == false &&
                      basicForm.get('show_prices')?.value == true
                    ) {
                      <patron-alert color="warning">
                        Os preços não serão exibidos devido a
                        <a routerLink="/configuracoes" target="_blank">configuração geral</a> da
                        empresa
                      </patron-alert>
                    }
                  </div>
                }
              </patron-form>

              @if (canLinkLicense) {
                @if (loadingLicenses) {
                  <patron-spinner></patron-spinner>
                } @else {
                  <div class="mb-3">
                    <label class="form-label" for="basicTabLicenseSelect">
                      {{
                        currentLicense
                          ? 'Assento de licença vinculado'
                          : 'Vincular a um assento de licença livre'
                      }}
                    </label>
                    <div class="d-flex gap-2">
                      <select
                        id="basicTabLicenseSelect"
                        class="form-select"
                        [disabled]="!!currentLicense"
                        [(ngModel)]="selectedLicenseId">
                        <option [ngValue]="null">Selecione um assento</option>
                        @if (currentLicense) {
                          <option [ngValue]="currentLicense.id">
                            {{ currentLicense.vendor_system?.name }} — assento
                            {{ currentLicense.number
                            }}{{ currentLicense.alias ? ' (' + currentLicense.alias + ')' : '' }}
                          </option>
                        }
                        @for (item of availableLicenses; track item.id) {
                          <option [ngValue]="item.id">
                            {{ item.vendor_system?.name }} — assento {{ item.number
                            }}{{ item.alias ? ' (' + item.alias + ')' : '' }}
                          </option>
                        }
                      </select>
                      @if (currentLicense) {
                        <patron-button
                          color="danger"
                          [loading]="linkingLicense"
                          (click)="unlinkLicense()">
                          Desvincular
                        </patron-button>
                      } @else {
                        <patron-button
                          color="primary"
                          [disabled]="!selectedLicenseId || linkingLicense"
                          [loading]="linkingLicense"
                          (click)="linkLicense()">
                          Vincular
                        </patron-button>
                      }
                    </div>
                    @if (!currentLicense && !availableLicenses.length) {
                      <small class="text-muted d-block mt-1">
                        Nenhum assento disponível para vincular agora — gere ou libere um em
                        "Licenças de usuário".
                      </small>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </ng-template>
        <ng-template #sellersTab>
          <div class="mb-3">
            <label class="form-label fw-semibold">Vendedor vinculado</label>
            <app-entity-picker
              title="Selecionar vendedor"
              placeholder="Nenhum vendedor selecionado"
              labelField="_name"
              [searchFn]="searchSellersFn"
              [value]="currentLinkedSeller"
              [disabled]="isSyncActive"
              (valueChange)="onSellerPickerChange($event)">
            </app-entity-picker>
          </div>
        </ng-template>
        <ng-template #customersTab>
          <patron-responsive-table
            [bodyTemplate]="customersBodyTemplate"
            [headerTemplate]="customersHeaderTemplate"
            [items]="customers"
            [findOptions]="customersFindOptions"
            [loading]="loadingCustomers"
            (sortChanged)="paginateCustomers($event)"
            [mobileSortable]="false"
            customEmptyMessage="Nenhum cliente"
            #customersTable>
            <ng-template #customersHeaderTemplate>
              <tr>
                <th>Cliente</th>
                <th class="text-center d-none d-lg-table-cell" style="width: 330px">Id</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
              </tr>
            </ng-template>
            <ng-template #customersBodyTemplate let-customer>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Cliente</strong>
                  </patron-rt-column-title>
                  <span [innerHTML]="customer.ref | highlight: customersFindOptions.q!"></span> -
                  <span [innerHTML]="customer.name | highlight: customersFindOptions.q!"></span>
                </td>
                <td class="text-center d-none d-lg-table-cell">
                  <patron-rt-column-title>
                    <strong>Id</strong>
                  </patron-rt-column-title>
                  {{ customer.id }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="customer.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="customer.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="customer.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="customer.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #itemsTab>
          <div class="mb-3">
            <patron-alert>
              <div class="flex flex-wrap align-items-center justify-content-between">
                <div>
                  <p class="mb-0 font-italic text-sm">
                    Para utilizar filtro de itens no <strong>Vendor</strong> verificar a aba
                    <a
                      href="javascript:void(0)"
                      class="font-bold"
                      (click)="tabview.activeIndex = 9">
                      Configurações específicas
                    </a>
                  </p>
                </div>
                @if (itemsTable?.checkedItems?.length; as count) {
                  <div class="flex align-items-center">
                    <span class="me-2"
                      >{{ count }} marcado
                      @if (count > 1) {
                        <span>s</span>
                      }
                    </span>
                    <patron-confirm-dialog
                      key="removeCheckedItems"
                      [data]="removeCheckedItemsConfirm"
                      (click)="openRemoveCheckedItemsConfirm(itemsTable.checkedItems)">
                    </patron-confirm-dialog>
                  </div>
                }
              </div>
            </patron-alert>
          </div>
          <patron-responsive-table
            [bodyTemplate]="itemsBodyTemplate"
            [headerTemplate]="itemsHeaderTemplate"
            [items]="items"
            [findOptions]="itemsFindOptions"
            bindValue="id"
            [loading]="loadingItems"
            (sortChanged)="paginateItems($event)"
            [mobileSortable]="false"
            customEmptyMessage="Nenhum item"
            #itemsTable>
            <ng-template #itemsHeaderTemplate>
              <tr>
                <th style="width: 37px">
                  <patron-form-check [inputTemplate]="checkInputTemplate1">
                    <ng-template #checkInputTemplate1>
                      <input
                        type="checkbox"
                        id="checkAll"
                        [checked]="itemsTable.isCheckedPage()"
                        (change)="itemsTable.toggleCheckPage()" />
                    </ng-template>
                  </patron-form-check>
                </th>
                <th>Item</th>
                <th class="text-center" style="width: 150px">Gtin</th>
                <th class="text-center d-none d-lg-table-cell" style="width: 330px">Id</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
                <th class="text-right" style="width: 50px"></th>
              </tr>
            </ng-template>
            <ng-template #itemsBodyTemplate let-item>
              <tr
                (click)="itemsTable.toggleCheck(item)"
                [class.bg-primary]="itemsTable.isChecked(item)">
                <td>
                  <patron-form-check
                    [inputTemplate]="checkInputTemplate"
                    [inputContext]="{ $implicit: item }">
                    <ng-template #checkInputTemplate let-item>
                      <input
                        type="checkbox"
                        [id]="item.id"
                        [checked]="itemsTable.isChecked(item)"
                        (change)="itemsTable.toggleCheck(item, true)" />
                    </ng-template>
                  </patron-form-check>
                </td>
                <td>
                  <patron-rt-column-title>
                    <strong>Item</strong>
                  </patron-rt-column-title>
                  <span [innerHTML]="item._description | highlight: itemsFindOptions.q!"></span>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Gtin</strong>
                  </patron-rt-column-title>
                  <span [innerHTML]="item.gtin | highlight: itemsFindOptions.q!"></span>
                </td>
                <td class="text-center d-none d-lg-table-cell">
                  <patron-rt-column-title>
                    <strong>Id</strong>
                  </patron-rt-column-title>
                  {{ item.id }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-right">
                  <patron-rt-column-title></patron-rt-column-title>
                  <patron-confirm-dialog
                    [key]="item.id"
                    [data]="removeItemConfirm"
                    (click)="openRemoveItemConfirm(item)"
                    (onHide)="onHideConfirmItemRemove()">
                  </patron-confirm-dialog>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #stockLocalesTab>
          <patron-responsive-table
            [items]="user?.stock_locales || []"
            [headerTemplate]="stockLocalesHeaderTemplate"
            [bodyTemplate]="stockLocalesBodyTemplate"
            customEmptyMessage="Nenhum local de estoque"
            #stockLocalesTable>
            <ng-template #stockLocalesHeaderTemplate>
              <tr>
                <th>Local de estoque</th>
                <th class="text-center" style="width: 100px">Padrão</th>
                <th class="text-center" style="width: 100px">Tipo</th>
                <th class="text-center" style="width: 100px">Contagem</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
                <th class="text-right" style="width: 50px"></th>
              </tr>
            </ng-template>
            <ng-template #stockLocalesBodyTemplate let-item>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Local de estoque</strong>
                  </patron-rt-column-title>
                  {{ item._name }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Padrão</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="item.main"
                    (handleChange)="setMainStockLocale(item)"
                    [trueValue]="1"
                    [falseValue]="0"
                    styleClass="justify-content-center">
                  </patron-switch>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Tipo</strong>
                  </patron-rt-column-title>
                  {{ item.type }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Contagem</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="item.is_counting"
                    (handleChange)="setCountingStockLocale(item)"
                    [trueValue]="1"
                    [falseValue]="0"
                    styleClass="justify-content-center">
                  </patron-switch>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-right">
                  <patron-rt-column-title></patron-rt-column-title>
                  <patron-confirm-dialog
                    [key]="item.id"
                    [data]="removeStockLocaleConfirm"
                    (click)="openRemoveStockLocaleConfirm(item)"
                    (onHide)="onHideConfirmStockLocaleRemove()">
                  </patron-confirm-dialog>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #priceTablesTab>
          <patron-responsive-table
            [items]="user?.price_tables || []"
            [headerTemplate]="priceTablesHeaderTemplate"
            [bodyTemplate]="priceTablesBodyTemplate"
            customEmptyMessage="Nenhuma tabela de preço"
            #priceTablesTable>
            <ng-template #priceTablesHeaderTemplate>
              <tr>
                <th>Tabela</th>
                <th class="text-center" style="width: 100px">Padrão</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
                <th class="text-right" style="width: 50px"></th>
              </tr>
            </ng-template>
            <ng-template #priceTablesBodyTemplate let-item>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Tabela</strong>
                  </patron-rt-column-title>
                  {{ item._description }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Padrão</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="item.main"
                    (handleChange)="setMainPriceTable(item)"
                    [trueValue]="1"
                    [falseValue]="0">
                  </patron-switch>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-right">
                  <patron-rt-column-title></patron-rt-column-title>
                  <patron-confirm-dialog
                    [key]="item.id"
                    [data]="removePriceTableConfirm"
                    (click)="openRemovePriceTableConfirm(item)"
                    (onHide)="onHideConfirmPriceTableRemove()">
                  </patron-confirm-dialog>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #paymentConditionsTab>
          <patron-responsive-table
            [items]="user?.payment_conditions || []"
            [headerTemplate]="paymentConditionsHeaderTemplate"
            [bodyTemplate]="paymentConditionsBodyTemplate"
            customEmptyMessage="Nenhuma condição de pagamento"
            #paymentConditionsTable>
            <ng-template #paymentConditionsHeaderTemplate>
              <tr>
                <th>Condição</th>
                <th class="text-center" style="width: 100px">Padrão</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
                <th class="text-right" style="width: 50px"></th>
              </tr>
            </ng-template>
            <ng-template #paymentConditionsBodyTemplate let-item>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Condição</strong>
                  </patron-rt-column-title>
                  {{ item._name }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Padrão</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="item.main"
                    (handleChange)="setMainPaymentCondition(item)"
                    [trueValue]="1"
                    [falseValue]="0">
                  </patron-switch>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-right">
                  <patron-rt-column-title></patron-rt-column-title>
                  <patron-confirm-dialog
                    [key]="item.id"
                    [data]="removePaymentConditionConfirm"
                    (click)="openRemovePaymentConditionConfirm(item)"
                    (onHide)="onHideConfirmPaymentConditionRemove()">
                  </patron-confirm-dialog>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #fiscalOperationsTab>
          <patron-responsive-table
            [items]="user?.fiscal_operations || []"
            [headerTemplate]="fiscalOperationsHeaderTemplate"
            [bodyTemplate]="fiscalOperationsBodyTemplate"
            customEmptyMessage="Nenhuma operação fiscal"
            #fiscalOperationsTable>
            <ng-template #fiscalOperationsHeaderTemplate>
              <tr>
                <th>Operação</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
              </tr>
            </ng-template>
            <ng-template #fiscalOperationsBodyTemplate let-item>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Operação</strong>
                  </patron-rt-column-title>
                  {{ item._description }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #companiesTab>
          <patron-responsive-table
            [items]="user?.companies || []"
            [headerTemplate]="companiesHeaderTemplate"
            [bodyTemplate]="companiesBodyTemplate"
            customEmptyMessage="Nenhuma empresa"
            #companiesTable>
            <ng-template #companiesHeaderTemplate>
              <tr>
                <th>Empresa</th>
                <th class="text-center" style="width: 100px">Padrão</th>
                <th class="text-center" style="width: 100px">Ativo</th>
                <th class="text-center" style="width: 100px">Mobile</th>
              </tr>
            </ng-template>
            <ng-template #companiesBodyTemplate let-item>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Empresa</strong>
                  </patron-rt-column-title>
                  {{ item._name }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Padrão</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="item.main"
                    (handleChange)="setMainCompany(item)"
                    [trueValue]="1"
                    [falseValue]="0">
                  </patron-switch>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Ativo</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.active ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.active ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Mobile</strong>
                  </patron-rt-column-title>
                  <patron-icon
                    [name]="item.go_to_mobile ? 'bi-check-circle' : 'bi-x-circle'"
                    [class]="item.go_to_mobile ? 'text-success' : 'text-danger'">
                  </patron-icon>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #departmentsTab>
          <patron-responsive-table
            [items]="userDepartments"
            [headerTemplate]="departmentsHeaderTemplate"
            [bodyTemplate]="departmentsBodyTemplate"
            [loading]="loadingUserDepartments"
            customEmptyMessage="Nenhum departamento"
            #departmentsTable>
            <ng-template #departmentsHeaderTemplate>
              <tr>
                <th>Departamento</th>
                <th class="text-center" style="width: 100px">Gerente</th>
                <th class="text-right" style="width: 50px"></th>
              </tr>
            </ng-template>
            <ng-template #departmentsBodyTemplate let-userDepartment>
              <tr>
                <td>
                  <patron-rt-column-title>
                    <strong>Departamento</strong>
                  </patron-rt-column-title>
                  {{ userDepartment.department?.name || userDepartment.department_id }}
                </td>
                <td class="text-center">
                  <patron-rt-column-title>
                    <strong>Gerente</strong>
                  </patron-rt-column-title>
                  <patron-switch
                    [(ngModel)]="userDepartment.manager"
                    (handleChange)="
                      updateManagerStatus(userDepartment.department_id, $event.checked)
                    "
                    [trueValue]="true"
                    [falseValue]="false"
                    styleClass="justify-content-center">
                  </patron-switch>
                </td>
                <td class="text-right">
                  <patron-rt-column-title></patron-rt-column-title>
                  <patron-confirm-dialog
                    [key]="userDepartment.id"
                    [data]="removeDepartmentConfirm"
                    (click)="openRemoveDepartmentConfirm(userDepartment)">
                  </patron-confirm-dialog>
                </td>
              </tr>
            </ng-template>
          </patron-responsive-table>
        </ng-template>
        <ng-template #specificTab>
          <div class="flex justify-content-center row">
            <div class="col-12">
              <div class="px-1 py-3">
                <patron-form [formGroup]="specificForm">
                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="read_all_customers"
                    [trueValue]="1"
                    [falseValue]="0"
                    label="Pode ver todos os clientes"
                    class="mr-4">
                  </patron-switch>

                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="itemFilter"
                    (handleChange)="itemFilterChange($event)"
                    label="Filtro de itens"
                    class="mr-4">
                  </patron-switch>

                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="itemExclude"
                    label="Utilizar filtro de itens para bloqueio"
                    class="mr-4">
                  </patron-switch>

                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="emit_nfe"
                    [trueValue]="1"
                    [falseValue]="0"
                    label="Pode gerar nota fiscal"
                    class="mr-4">
                  </patron-switch>
                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="order_counterpassword"
                    [trueValue]="1"
                    [falseValue]="0"
                    label="Pede contra senha no pedido"
                    class="mr-4">
                  </patron-switch>
                  <patron-switch
                    inline
                    [formGroup]="specificForm"
                    formControlName="can_use_campaign"
                    [trueValue]="1"
                    [falseValue]="0"
                    label="Pode usar campanhas"
                    class="mr-4">
                  </patron-switch>
                </patron-form>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-header">Regras de limite para descontos</div>
                <div class="card-body p-0">
                  <ul patron-list-group [flush]="true">
                    @for (
                      discountLimit of user?.config?.discountLimit;
                      track discountLimit;
                      let i = $index
                    ) {
                      <li
                        patron-list-group-item
                        [class.surface-ground]="discountLimitEditIndex == i">
                        <div class="row pt-3">
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 70px">
                                <span class="input-group-text">De R$</span>
                              </div>
                              <input
                                currencyMask
                                class="form-control form-control-sm"
                                [(ngModel)]="discountLimit.minValue"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="{
                                  prefix: '',
                                  thousands: '.',
                                  decimal: ',',
                                  align: 'left',
                                }"
                                [disabled]="discountLimitEditIndex != i" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 70px">
                                <span class="input-group-text">Até R$</span>
                              </div>
                              <input
                                currencyMask
                                class="form-control form-control-sm"
                                [(ngModel)]="discountLimit.maxValue"
                                [ngModelOptions]="{ standalone: true }"
                                [options]="{
                                  prefix: '',
                                  thousands: '.',
                                  decimal: ',',
                                  align: 'left',
                                }"
                                [disabled]="discountLimitEditIndex != i" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="flex align-items-center justify-content-between">
                              <div class="input-group input-group-sm mr-2">
                                <div class="input-group-prepend" style="width: 70px">
                                  <span class="input-group-text">Máx</span>
                                </div>
                                <input
                                  type="number"
                                  class="form-control form-control-sm"
                                  [(ngModel)]="discountLimit.discount"
                                  [ngModelOptions]="{ standalone: true }"
                                  [disabled]="discountLimitEditIndex != i" />
                                <div class="input-group-append">
                                  <span class="input-group-text">%</span>
                                </div>
                              </div>
                              @if (discountLimitEditIndex != i) {
                                <div class="flex">
                                  <patron-button
                                    iconName="bi-pencil"
                                    class="mr-1"
                                    (click)="discountLimitEditIndex = i">
                                  </patron-button>
                                  <patron-button
                                    iconName="bi-trash3"
                                    color="danger"
                                    (click)="removeDiscountLimit(i)"
                                    [loading]="savingUser">
                                  </patron-button>
                                </div>
                              }
                              @if (discountLimitEditIndex == i) {
                                <div class="flex">
                                  <patron-button
                                    iconName="bi-check2"
                                    class="mr-1"
                                    (click)="saveUser()"
                                    [loading]="savingUser">
                                  </patron-button>
                                  <patron-button
                                    iconName="bi-x"
                                    color="secondary"
                                    (click)="cancelEditDiscountLimit()">
                                  </patron-button>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </li>
                    }
                    <li patron-list-group-item class="surface-ground">
                      <div class="row pt-3">
                        <div class="col-lg-4 mb-3">
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend" style="width: 70px">
                              <span class="input-group-text">De R$</span>
                            </div>
                            <input
                              currencyMask
                              class="form-control form-control-sm"
                              [(ngModel)]="newDiscountLimit.minValue"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="{
                                prefix: '',
                                thousands: '.',
                                decimal: ',',
                                align: 'left',
                              }" />
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                          <div class="input-group input-group-sm">
                            <div class="input-group-prepend" style="width: 70px">
                              <span class="input-group-text">Até R$</span>
                            </div>
                            <input
                              currencyMask
                              class="form-control form-control-sm"
                              [(ngModel)]="newDiscountLimit.maxValue"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="{
                                prefix: '',
                                thousands: '.',
                                decimal: ',',
                                align: 'left',
                              }" />
                          </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                          <div class="flex align-items-center justify-content-between">
                            <div class="input-group input-group-sm me-2">
                              <div class="input-group-prepend" style="min-width: 70px">
                                <span class="input-group-text">Máx</span>
                              </div>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                [(ngModel)]="newDiscountLimit.discount"
                                [ngModelOptions]="{ standalone: true }" />
                              <div class="input-group-append">
                                <span class="input-group-text">%</span>
                              </div>
                            </div>

                            <patron-button
                              iconName="bi-plus"
                              (click)="addDiscountLimit()"></patron-button>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #systemLicensesTab>
          <bw-user-licenses [bwUserId]="bwUser?.id" [userName]="bwUser?.name"></bw-user-licenses>
        </ng-template>
        <ng-template #licensesTab>
          <div class="flex justify-content-center row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">Licenças por plataforma</div>
                <div class="card-body p-0">
                  <ul patron-list-group [flush]="true">
                    <li patron-list-group-item class="surface-ground">
                      <patron-form [formGroup]="licensesForm">
                        <div class="row pt-3">
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 70px">
                                <span class="input-group-text">Web</span>
                              </div>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                formControlName="licenses_web"
                                [formGroup]="licensesForm" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 70px">
                                <span class="input-group-text">Mobile</span>
                              </div>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                formControlName="licenses_mobile"
                                [formGroup]="licensesForm" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="flex align-items-center justify-content-between">
                              <patron-button
                                iconName="bi-check2"
                                color="success"
                                (click)="saveUser()"></patron-button>
                            </div>
                          </div>
                        </div>
                      </patron-form>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #templatesTab>
          <div class="flex justify-content-center row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">Tipos de Templates</div>
                <div class="card-body p-0">
                  <ul patron-list-group [flush]="true">
                    <li patron-list-group-item class="surface-ground">
                      <patron-form [formGroup]="reportsChartsForm">
                        <div class="row pt-3">
                          <div class="col-6 mb-3 d-flex align-items-center">
                            <patron-select
                              label="Tipo de gráfico"
                              [formGroup]="reportsChartsForm"
                              [multiple]="true"
                              placeholder="Selecione o tipo de gráfico"
                              bindLabel="title"
                              bindValue="id"
                              formControlName="reports_charts"
                              modelName="reports_charts">
                            </patron-select>
                            <patron-button
                              iconName="bi-check2"
                              color="success"
                              (click)="saveUser()"
                              class="ml-4"></patron-button>
                          </div>
                        </div>
                      </patron-form>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #metasTab>
          <div class="flex justify-content-center row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">Metas de Vendas</div>
                <div class="card-body p-0">
                  <ul patron-list-group [flush]="true">
                    <li patron-list-group-item class="surface-ground">
                      <patron-form [formGroup]="salesGoalsForm">
                        <div class="row pt-3">
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 100px">
                                <span class="input-group-text">Meta diária</span>
                              </div>
                              <input
                                currencyMask
                                class="form-control form-control-sm"
                                [formGroup]="salesGoalsForm"
                                formControlName="daily_sales_goals"
                                [options]="{
                                  prefix: '',
                                  thousands: '.',
                                  decimal: ',',
                                  align: 'left',
                                }" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="input-group input-group-sm">
                              <div class="input-group-prepend" style="width: 110px">
                                <span class="input-group-text">Meta Mensal</span>
                              </div>
                              <input
                                currencyMask
                                class="form-control form-control-sm"
                                [formGroup]="salesGoalsForm"
                                formControlName="monthly_sales_goals"
                                [options]="{
                                  prefix: '',
                                  thousands: '.',
                                  decimal: ',',
                                  align: 'left',
                                }" />
                            </div>
                          </div>
                          <div class="col-lg-4 mb-3">
                            <div class="flex align-items-center justify-content-between">
                              <patron-button
                                iconName="bi-check2"
                                color="success"
                                (click)="saveUser()"></patron-button>
                            </div>
                          </div>
                        </div>
                      </patron-form>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #pipelinesTab>
          <app-pipeline-access owner="user" [ownerId]="bwUser?.id" />
        </ng-template>
      </patron-tabview>
    </div>
  </div>
</div>

<patron-toolbar
  position="bottom"
  [class.hidden]="tabview.activeIndex != 2 && tabview.activeIndex != 3">
  @if (user?.id && tabview.activeIndex == 2) {
    <patron-paginator
      [totalRecords]="totalCustomers"
      [findOptions]="customersFindOptions"
      (onPageChange)="paginateCustomers($event)"
      #customersPaginator>
    </patron-paginator>
  }
  @if (user?.id && tabview.activeIndex == 3) {
    <patron-paginator
      [totalRecords]="totalItems"
      [findOptions]="itemsFindOptions"
      (onPageChange)="paginateItems($event)"
      #itemsPaginator>
    </patron-paginator>
  }
</patron-toolbar>

@if (loadingUser || savingBwUser || savingUser) {
  <patron-overlay></patron-overlay>
}

<patron-modal
  title="Clonar dados de outro usuário"
  [visible]="cloneModalVisible"
  confirmButtonText="Clonar dados"
  (confirm)="openCloneUserConfirm()"
  confirmButtonIcon="bi-check-lg">
  @if (cloneForm) {
    <div>
      <patron-form [formGroup]="cloneForm">
        <patron-select
          [formGroup]="cloneForm"
          formControlName="attributes"
          bindLabel="label"
          label="Copiar"
          [multiple]="true"
          [items]="cloneOptions">
        </patron-select>
        <patron-select
          [formGroup]="cloneForm"
          formControlName="userClone"
          bindLabel="_name"
          label="Usuário a ser copiado"
          modelName="users"
          orderBy="name">
        </patron-select>
        <div class="py-6"></div>
      </patron-form>
    </div>
  }
</patron-modal>

<patron-modal
  title="Senha do Gestão Administrativa"
  [visible]="managementPasswordModalVisible"
  confirmButtonText="Confirmar"
  cancelButtonText="Cancelar"
  confirmButtonIcon="bi-shield-lock"
  (confirm)="reinstallUserPasswordFromGestao()"
  (cancel)="managementPasswordModalVisible = false"
  [confirmButtonLoading]="managementPasswordLoading"
  [backdrop]="true"
  size="lg">
  <span class="d-block fs-5 mb-3"
    >Atualizar a senha do usuário web com a senha do Gestão Administrativa?</span
  >
  <ul patron-list-group class="my-4">
    <li patron-list-group-item><strong>Nome:</strong> {{ bwUser?.name }}</li>
    <li patron-list-group-item><strong>Email:</strong> {{ bwUser?.email }}</li>
    <li patron-list-group-item><strong>Tipo:</strong> {{ bwUser?.is_user ? 'Usuário' : '-' }}</li>
  </ul>
  <span class="d-block mt-2 small text-primary"
    ><em>- Necessário Fenix F2_26.1.1 ou mais recente.</em></span
  >
  <span class="d-block mt-2 small text-primary"
    ><em
      >- Após o processo, utilize a última senha informada no sistema de gestão para acessar os
      sistemas web.</em
    ></span
  >
</patron-modal>

<patron-modal
  title="Confirmar ação"
  [visible]="cloneConfirmModalVisible"
  confirmButtonText="Sim, clonar"
  (confirm)="cloneUserData()"
  cancelButtonText="Cancelar"
  confirmButtonIcon="bi-check-lg"
  (cancel)="cancelClone()"
  [confirmButtonLoading]="cloneLoading"
  [backdrop]="true">
  {{ cloneConfirmMessage }}
  <div class="my-4">
    <patron-alert color="warning">
      <b>Atenção!</b>
      <p>{{ cloneConfirmWarningMessage }}</p>
    </patron-alert>
  </div>
</patron-modal>

<patron-modal
  title="Resetar senha do acesso"
  [visible]="resetPasswordModalVisible"
  [confirmButtonText]="bwUser?.generated_password ? 'Gerar outra senha' : 'Sim, gerar nova senha'"
  (confirm)="generateNewRandomPassword()"
  cancelButtonText="Cancelar"
  confirmButtonIcon="bi-check-lg"
  (cancel)="resetPasswordModalVisible = false"
  [confirmButtonLoading]="resetPasswordLoading"
  [backdrop]="true">
  Deseja gerar uma nova senha para esse acesso?
  <ul patron-list-group class="my-4">
    <li patron-list-group-item><strong>Nome:</strong> {{ bwUser?.name }}</li>
    <li patron-list-group-item><strong>Email:</strong> {{ bwUser?.email }}</li>
    <li patron-list-group-item><strong>Usuario:</strong> {{ bwUser?.is_user ? 'Sim' : 'Não' }}</li>
    <li patron-list-group-item>
      <strong>Cliente:</strong> {{ bwUser?.is_customer ? 'Sim' : 'Não' }}
    </li>
    <li patron-list-group-item>
      <strong>Fornecedor:</strong> {{ bwUser?.is_supplier ? 'Sim' : 'Não' }}
    </li>
  </ul>
  <div class="my-4">
    <patron-alert>
      <ul>
        <li>Será gerada uma nova senha aleatória</li>
        <li>
          A senha poderá ser alterada
          {{ bwUser?.name ? 'por ' + bwUser?.name : 'pelo usuário' }} quando ele acessar
        </li>
        <li>
          {{ bwUser?.name ? bwUser?.name : 'O usuário' }} receberá a nova senha em seu email
          <strong>{{ bwUser?.email }}</strong>
        </li>
      </ul>
    </patron-alert>
  </div>
  @if (bwUser?.generated_password) {
    <div class="my-4">
      <patron-alert color="info">
        <div class="text-center">
          Nova senha: <strong class="ms-2">{{ bwUser?.generated_password }}</strong>
        </div>
      </patron-alert>
    </div>
  }
</patron-modal>
